/**
 *
 * @param {number} value - number to convert to a string in currency format
 * @return {string} value - converted numerical string
 *
 * Takes a number and turns it into USD currency format string, with commas and two decimals added
 */
function formatCurrencyString(value) {
  return value
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default formatCurrencyString;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/formatCurrencyString.js